module.exports = __webpack_public_path__ + "img/feather-pointed.f66a8540.svg";